/* ============
 * Actions for the delegate module
 * ============
 *
 * The actions that are available on the
 * delegate module.
 */
import Vue from 'vue';
import DelegateProxy from '@/proxies/DelegateProxy';
import message from '@/constants/_message';
import types from './mutation-types';

export const getDelegates = ({ commit }, data) => {
  commit(types.FETCH_DELEGATE_LIST);
  new DelegateProxy().fetchDelegates(data).then((response) => {
    commit(types.FETCH_DELEGATE_LIST_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_DELEGATE_LIST_SUCCESS, error);
  });
};

export const updateDelegate = ({ commit }, {
  data,
  successMessage,
  failureMessage,
  patient
}) => {
  commit(types.UPDATE_DELEGATE);
  new DelegateProxy().updateDelegate(data).then((response) => {
    commit(types.UPDATE_DELEGATE_SUCCESS, { response, patient });
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: successMessage || message.DELEGATE_UPDATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.UPDATE_DELEGATE_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: failureMessage || message.DELEGATE_NOT_UPDATED,
      type: 'error'
    });
  });
};

export default {
  getDelegates,
  updateDelegate
};
